import { erpAxios } from '..';

const getStepenRizika = async () => {
  const { data } = await erpAxios.get('/stepenRizika');
  return data;
};

export default getStepenRizika;
